var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Iceland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M43.598,20C41.745,10.871,33.676,4,24,4c-0.338,0-0.667,0.034-1,0.05V20H43.598z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M4.402,28C5.634,34.071,9.625,39.126,15,41.843V28H4.402z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M15,6.157C9.625,8.874,5.634,13.929,4.402,20H15V6.157z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M23,43.95c0.333,0.017,0.662,0.05,1,0.05c9.676,0,17.745-6.871,19.598-16H23V43.95z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M17,5.284c-0.685,0.256-1.353,0.545-2,0.873V20H4.402c-0.133,0.656-0.233,1.323-0.301,2H17V5.284z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M4.101,26c0.067,0.677,0.167,1.344,0.301,2H15v13.843c0.647,0.327,1.315,0.616,2,0.873V26H4.101z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M23,20V4.05c-0.676,0.034-1.343,0.099-2,0.199V22h22.899c-0.067-0.677-0.167-1.344-0.301-2H23z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M21,43.751c0.657,0.099,1.324,0.165,2,0.199V28h20.598c0.133-0.656,0.233-1.323,0.301-2H21V43.751z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M21,4.249c-1.386,0.209-2.723,0.557-4,1.035V22H4.101C4.036,22.658,4,23.325,4,24 s0.036,1.342,0.101,2H17v16.716c1.277,0.478,2.614,0.826,4,1.035V26h22.899C43.964,25.342,44,24.675,44,24s-0.036-1.342-0.101-2H21 V4.249z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Iceland);
export default __webpack_public_path__ + "static/media/icons8-iceland.ba369713630dcf7b1176539ba97ad5b8.svg";
export { ForwardRef as ReactComponent };